module.exports = __webpack_public_path__ + "img/venue.d0f9c98f.png";